// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"875bc852","821":"a5b6ab90","977":"7907a4ad"}[chunkId] + ".chunk.js";
};